export default __webpack_public_path__ + "media/Compass_tablet.793b9a850429e843373d2e2812b17265.svg";